var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup388(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.46826 10.4711C7.8144 10.9338 8.25602 11.3167 8.76315 11.5938C9.27028 11.8709 9.83107 12.0356 10.4075 12.0769C10.9839 12.1182 11.5624 12.035 12.1039 11.833C12.6453 11.6311 13.137 11.315 13.5455 10.9063L15.9636 8.4883C16.6977 7.72823 17.1039 6.71023 17.0947 5.65357C17.0855 4.59691 16.6617 3.58614 15.9145 2.83894C15.1673 2.09174 14.1565 1.6679 13.0998 1.65872C12.0432 1.64954 11.0252 2.05574 10.2651 2.78984L8.87877 4.16811",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6925 8.85902C10.3463 8.39627 9.90473 8.01337 9.39759 7.7363C8.89046 7.45923 8.32967 7.29447 7.75326 7.25319C7.17686 7.2119 6.59831 7.29507 6.05687 7.49704C5.51543 7.69902 5.02376 8.01507 4.61521 8.42377L2.19719 10.8418C1.46309 11.6019 1.05689 12.6199 1.06607 13.6765C1.07525 14.7332 1.49909 15.7439 2.24628 16.4911C2.99348 17.2383 4.00426 17.6622 5.06092 17.6714C6.11758 17.6805 7.13557 17.2743 7.89565 16.5402L9.27391 15.162",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup388);
export default __webpack_public_path__ + "static/media/Group388.7c0fca3a64c153466a3729284fa4f7d4.svg";
export { ForwardRef as ReactComponent };